import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetAcademicLevelsQuery } from "../../hooks/useGetAcademicLevelsQuery";
import { updateAcademicLevel } from "../../services/school/academicLevel";
import { Key_AcademicLevels } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { AcademicLevelType } from "../../types/AcademicLevelType";
import { setAcademicLevelData } from "../../redux/slices/school/academicLevel";

const columnNamesMap: { [key: string]: string } = {
    description: "Nome",
    // code: "Código",
};

export const AcademicLevels = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<AcademicLevelType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetAcademicLevelsQuery({ PageNumber: currentPage, PageSize: 10 });

    const mutationUpdate = useMutation(updateAcademicLevel, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_AcademicLevels);
            toast.success("Nível académico removido com sucesso");
        },
        onError: () => {
            toast.error("Erro ao remover o nível académico.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createAcademicLevel);
    };

    const handleEdit = (level: AcademicLevelType) => {
        dispatch(setAcademicLevelData(level));
        navigate(routes.updateAcademicLevel);
    };

    const handleDelete = (level: AcademicLevelType) => {
        level.status = false;
        mutationUpdate.mutateAsync(level);
    };

    const openDeleteDialog = (level: AcademicLevelType) => {
        setItemToBeDeleted(level);
    };

    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted);
        }
    };

    const options = data?.items.map((level) => [
        {
            label: "Editar",
            onClick: () => handleEdit(level),
            icon: <Pencil1Icon />
        },
        {
            label: "Eliminar",
            onClick: () => openDeleteDialog(level),
            icon: <TrashIcon />
        },
    ]) || [];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                )}
                handleClickCreate={handleCreate}
            />
            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Esta operação é irreversível"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />
        </>
    );
};
